/* wsapi3-blogs v1.0 */
/* Deploy Version 2026-10-14 10:42:30 */
/* Deploy Version 2026-09-24 19:11:08 */
/* Deploy Version 2026-09-23 */
/*
 * ws-blogs — API v3
 *
 * A versão v2 deste módulo (function: "create") dependia de variáveis globais de
 * página (`artigos`, `artigosPaginas`, `artigo`) que o storefront ASP antigo
 * imprimia inline. No stack v3 nada emite essas globais, então a página de blog
 * renderizava vazia (ReferenceError silencioso em create()).
 *
 * Agora busca direto da API v3, mantendo exatamente o mesmo contrato de DOM do
 * wsapi3-blogs.html / .css:
 *   - GET /store/blog/list?page=&page_size=   -> etapa BLOG      (listagem + paginação)
 *   - GET /store/blog/view?id= | ?slug=       -> etapa BLOG_VIEW (artigo único)
 */
wsMain.createModule({
  name: "ws-blogs",
  version: '1.0',
  updatedAt: '2026-09-23',
  function: "get",

  PAGE_SIZE: 10,

  async get() {
    const holder = document.querySelector('.blog-page-container');
    if (!holder) return true;

    const pageStep = document.querySelector('#HdEtapaLoja')?.value;

    try {
      if (pageStep === 'BLOG') {
        await wsMain.modules['ws-blogs'].renderList();
      } else if (pageStep === 'BLOG_VIEW') {
        await wsMain.modules['ws-blogs'].renderArticle();
      }
    } catch (err) {
      console.error('[ws-blogs] falha ao montar a página de blog:', err);
    }

    return true;
  },

  _currentPage() {
    const raw = new URLSearchParams(window.location.search).get('pagina');
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  },

  async renderList() {
    // Etapa de listagem: o holder do artigo único não é usado.
    document.querySelector('[data-wsjs-blog="article-holder"]')?.remove();

    const listEl = document.querySelector('[data-wsjs-blog="list"]');
    const pageListEl = document.querySelector('[data-wsjs-blog="pagination"]');
    if (!listEl) return;

    // Já montada no servidor (BlogServerRenderService) — o append() abaixo duplicaria os itens.
    if (listEl.hasAttribute('data-ws-rendered')) return;

    const page = wsMain.modules['ws-blogs']._currentPage();
    const resp = await ApiWS.Calls._get('/store/blog/list', {
      page,
      page_size: wsMain.modules['ws-blogs'].PAGE_SIZE,
    });

    const records = resp && Array.isArray(resp.records) ? resp.records : [];

    if (!records.length) {
      pageListEl?.remove();
      return;
    }

    records.forEach((article) => {
      const item = wsMain.tools.createElm({
        type: 'div',
        attrs: { class: 'blog-pages-item' },
      });

      const anchor = wsMain.tools.createElm({
        type: 'a',
        innerHTML: article.title || '',
        attrs: { href: article.url || ('/blog/' + (article.slug || '')) },
      });

      // v2 marcava indisponível com != 1; v3 manda published: boolean.
      if (article.published === false) item.classList.add('unavaliable');

      item.append(anchor);
      listEl.append(item);
    });

    if (!pageListEl) return;

    const totalPages = Number(resp.total_pages) || 1;
    if (totalPages <= 1) {
      pageListEl.remove();
      return;
    }

    // Mesma janela de +-4 páginas ao redor da atual que a v2 usava.
    const current = Number(resp.current_page) || page;
    const start = Math.max(1, current - 4);
    const end = Math.min(totalPages, current + 4);

    for (let n = start; n <= end; n++) {
      const li = wsMain.tools.createElm({
        type: 'li',
        attrs: { class: 'blog-pagination-item' },
      });
      if (n === current) li.classList.add('active');

      const a = wsMain.tools.createElm({
        type: 'a',
        innerHTML: n,
        attrs: { href: `/blog/?pagina=${n}` },
      });

      li.append(a);
      pageListEl.append(li);
    }
  },

  async renderArticle() {
    // Etapa de artigo: a listagem não é usada.
    document.querySelector('[data-wsjs-blog="list-holder"]')?.remove();

    const articleHolder = document.querySelector('[data-wsjs-blog="article-holder"]');

    // Já preenchido no servidor (BlogServerRenderService) — evita um segundo fetch.
    if (articleHolder?.hasAttribute('data-ws-rendered')) return;

    // id vem do resource resolvido no servidor (__WS_SERVER_DATA__.page.resourceId);
    // slug como fallback é o último segmento de /blog/<slug>.
    const resourceId = String(window.__WS_SERVER_DATA__?.page?.resourceId || '').trim();
    const slug = window.location.pathname.split('/').filter(Boolean).pop() || '';
    const params = resourceId ? { id: resourceId } : { slug };

    const resp = await ApiWS.Calls._get('/store/blog/view', params);
    const record = resp && resp.record ? resp.record : null;

    if (!record) {
      articleHolder?.remove();
      return;
    }

    // Chaves batem com os data-wsjs-blog="article-*" do wsapi3-blogs.html.
    const map = {
      titulo: record.title || '',
      subtitulo: record.subtitle || '',
      data: record.date_formatted || record.date || '',
      foto: record.image
        ? `<img src="${record.image}" alt="${String(record.title || '').replace(/"/g, '&quot;')}"/>`
        : '',
      conteudo: record.content || '',
    };

    Object.keys(map).forEach((k) => {
      document
        .querySelectorAll(`[data-wsjs-blog="article-${k}"]`)
        .forEach((el) => { el.innerHTML = map[k]; });
    });

    document
      .querySelectorAll('[data-wsjs-blog="exitButton"]')
      .forEach((el) => el.setAttribute('href', '/blog'));
  },
});
